import React, { useEffect } from 'react'
import { X, ChevronLeft, ChevronRight } from 'lucide-react'

export default function Lightbox({ images, currentIndex, onClose, onNext, onPrev }) {
  // Luk ved tryk på Escape-tasten og naviger med piletasterne
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose()
      if (e.key === 'ArrowRight') onNext()
      if (e.key === 'ArrowLeft') onPrev()
    }
    window.addEventListener('keydown', handleKeyDown)
    // Forhindre scroll på baggrunden, når lightboxen er åben
    document.body.style.overflow = 'hidden'

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      document.body.style.overflow = 'unset'
    }
  }, [onClose, onNext, onPrev])

  if (currentIndex === null || !images || images.length === 0) return null

  const currentImage = images[currentIndex]

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-sm select-none">
      {/* Luk-knap */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 z-55 p-3 rounded-full bg-neutral-900/80 hover:bg-neutral-800 text-white transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-amber-500"
        aria-label="Luk visning"
      >
        <X className="w-6 h-6" />
      </button>

      {/* Forrige-knap */}
      {images.length > 1 && (
        <button
          onClick={onPrev}
          className="absolute left-4 z-55 p-3 rounded-full bg-neutral-900/80 hover:bg-neutral-800 text-white transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-amber-500"
          aria-label="Forrige billede"
        >
          <ChevronLeft className="w-6 h-6" />
        </button>
      )}

      {/* Billede container */}
      <div className="max-w-5xl max-h-[85vh] px-4 flex flex-col items-center justify-center" onClick={(e) => e.stopPropagation()}>
        <img
          src={currentImage}
          alt={`Galleri billede ${currentIndex + 1}`}
          className="max-w-full max-h-[80vh] object-contain rounded-lg shadow-2xl border border-neutral-800"
        />
        <p className="text-neutral-400 text-sm mt-4 font-semibold tracking-wide">
          Billede {currentIndex + 1} af {images.length}
        </p>
      </div>

      {/* Næste-knap */}
      {images.length > 1 && (
        <button
          onClick={onNext}
          className="absolute right-4 z-55 p-3 rounded-full bg-neutral-900/80 hover:bg-neutral-800 text-white transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-amber-500"
          aria-label="Næste billede"
        >
          <ChevronRight className="w-6 h-6" />
        </button>
      )}

      {/* Luk ved klik på baggrunden */}
      <div className="absolute inset-0 -z-10 cursor-zoom-out" onClick={onClose} />
    </div>
  )
}
